define('lib/gotomeetme/get-steps-image-url',['require','i18next'],function (require) {
    var i18n = require('i18next');

    /**
     * Images used in multiple locations used to promote G2MM.
     * These images have been localized, and so require some logic to get the correct ones.
     */
    return function (fileName) {
        if (i18n.lng()) {
            var baseLanguage = i18n.lng().substring(0, 2);
            var baseUrl = '//cdn.gotomeet.at/images/web-portal/gotomeet/setup/';
            return baseUrl + fileName + '-' + baseLanguage + '.png';
        }
        return undefined;
    };
});

